module.exports = __webpack_public_path__ + "static/media/group.871f8b32.svg";